import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const dejavnostService = {
    load,loadAll,save,remove,loadPreteklaSezona
    
};

function load(sezona,predelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dejavnost/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(dejavnost => {
            // login successful if there's a jwt token in the response
            
            return dejavnost;
        });
}

function loadPreteklaSezona(sezona,predelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dejavnost/preteklasezona/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(dejavnost => {
            // login successful if there's a jwt token in the response
            
            return dejavnost;
        });
}


function save(dejavnost) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(dejavnost)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dejavnost`, requestOptions).then(handleResponse);
}


function remove(dejavnost) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(dejavnost)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dejavnost`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/predelava/dejavnosti/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(dejavnost => {
            // login successful if there's a jwt token in the response
            
            return dejavnost;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dejavnost/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(dejavnost => {
            // login successful if there's a jwt token in the response
            
            return dejavnost;
        });

}
